const classColor = (state) => (classe, index) => {
  return state.classColors[classe] || state.colors.paleta[index] || '#6C757D'
}

const colors = (state) => {
  return state.colors[state.colors.mode]
}

const paleta = (state) => {
  return state.colors.paleta
}

const logo = (state) => {
  return state.logo
}

const bg = (state) => {
  return state.backgroundImage
}

const escritorio = (state) => {
  return state.escritorio || {}
}

export { classColor, colors, paleta, logo, bg, escritorio }
